import PropTypes from 'prop-types';
import Drawer from '@mui/material/Drawer';
import useCssVars from './use-css-vars';
import { NavContent } from './nav-content';
import { COMPONENTS } from '@theme/admin';

export const SideNav = (props) => {
  const { sections, loading = false } = props;
  const cssVars = useCssVars();

  return (
    <Drawer
      anchor="left"
      open
      slotProps={{
        paper: {
          sx: {
            ...cssVars,
            backgroundColor: 'var(--nav-bg)',
            borderRightColor: 'var(--nav-border-color)',
            borderRightStyle: 'solid',
            borderRightWidth: 1,
            color: 'var(--nav-color)',
            width: COMPONENTS.SIDE_NAV_WIDTH,
          },
        },
      }}
      variant="permanent"
    >
      <NavContent sections={sections} loading={loading} />
    </Drawer>
  );
};

SideNav.propTypes = {
  sections: PropTypes.array,
  loading: PropTypes.bool,
};
